import React from 'react'
import moment from 'moment'
import { func, object } from 'prop-types'
import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left'
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right'
import styles from './MobileWeekTable.styl'
import { withContext } from '../../../utils/withContext'
import WeekWorkoutSummary from '../WeekWorkoutSummary/WeekWorkoutSummary'
import { translateSport, translateGround, translateType, translateMonth } from '../../helpers/helpers'

class MobileWeekTable extends React.Component {

	static propTypes = {
		onChange: func,
		week: object,
		date: object,
		context: object
	}

	state = {
		weekState: 0,
		workoutState: new Array(7).fill(false).map((_, i) => {
			const today = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1
			if (i === today) {
				return true
			}
			return false
		})
	}
	// TODO: Scrol into todays workout view!!

	scrollToToday() {
		if (!window) { return }
		this.scrollElement = !this.scrollElement ? window.document.querySelector('#today') : null
		if (this.scrollElement) {
			this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
			this.scrollElement = null
		}
	}
	renderDateTitle() {
		const { date } = this.props
		const endDate = moment.utc(date.valueOf()).add(6, 'days').endOf('day')
		return <h3>{ `${ date.date() } de ${ translateMonth[date.month()] } - ${ endDate.date() } de ${ translateMonth[endDate.month()] }` }</h3>
	}

	renderWeek() {
		const { week, context: { translationHelper: { translateDay } } } = this.props
		const { workoutState } = this.state
		const parsedWorkouts = new Array(7).fill({}).map((ele, i) => {
			const currentDay = (week['workouts'] || []).find(workout => (workout['day'] === i && workout['priority'] === 'primary'))
			const currentDaySecondary = (week['workouts'] || []).find(workout => (workout['day'] === i && workout['priority'] === 'secondary'))
			if (!currentDay) {
				return { title: translateDay(i), enabled: false }
			}
			return { title: translateDay(i), enabled: true, ...currentDay, secondary: currentDaySecondary }
		})
		return parsedWorkouts.map((parsedWorkout, index) => (
			<WeekWorkoutSummary
				key={ index }
				workout={ parsedWorkout }
				isExpanded={ workoutState[index] }
				onClick={ () => {
					this.setState(prevState => ({ workoutState: [...prevState['workoutState'].slice(0, index), !prevState['workoutState'][index], ...prevState['workoutState'].slice(index + 1)] }))
				} }
			/>)
		)
	}

	render() {
		const { weekState } = this.state
		const { week } = this.props
		return (
			<div>
				<nav className={ styles.nav }>
					<ul className={ styles.weekNav }>
						<li
							className={ styles.arrow } onClick={ () => {
								if (weekState === -2) { return }
								this.setState(prevState => ({ weekState: prevState.weekState - 1, workoutState: new Array(7).fill(false) }))
								this.props.onChange(-1)
							} }
						><FaArrowCircleLeft /></li>
						<li>
							{ this.renderDateTitle() }
							{ week && week.weekYear ? <p>{ `Microciclo ${ week.weekYear } - ${ new Date().getFullYear() }` }</p> : <p>Microciclo</p> }
						</li>
						<li
							className={ styles.arrow } onClick={ () => {
								if (weekState === 1) { return }
								this.setState(prevState => ({ weekState: prevState.weekState + 1, workoutState: new Array(7).fill(false) }))
								this.props.onChange(1)
							} }
						><FaArrowCircleRight /></li>
					</ul>
				</nav>
				<ul className={ styles['workout-list'] }>
					{ this.renderWeek() }
				</ul>
			</div>
		)
	}
}

export default withContext(MobileWeekTable)



// WEBPACK FOOTER //
// ./src/client/webapp/components/MobileWeekTable/MobileWeekTable.js